import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import { useMatchAtLeastOneRole } from 'utils/hooks';
import { RoleNames } from 'utils/constants';

import SubscriptionTable from './SubscriptionTable';
import ExternalSubscription from './ExternalSubscription';
import SubscriptionDetails from './subscription-details/SubscriptionDetails';
import { ListContainer } from 'components';

const Subscriptions = () => {
    const { path } = useRouteMatch();
    const userIsStandardServicer = useMatchAtLeastOneRole([RoleNames.SERVICER_STANDARD]);

    return (
        <ListContainer>
            <Switch>
                <Route
                    path={`${path}/details/:userId/:subscriptionId?`}
                    component={SubscriptionDetails}
                />
                {!userIsStandardServicer && (
                    <Route path={`${path}/create-external`} component={ExternalSubscription} />
                )}
                <Route path={path} render={() => <SubscriptionTable />} />
            </Switch>
        </ListContainer>
    );
};

export default Subscriptions;
